// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3YD37","question":"Question_question__2C7cc","description":"Question_description__om_F5"};